
function pickerFilter ($filter) {
	return function(value, filterName) {
		if (filterName) {
			return $filter(filterName)(value);
		}
		return value;
	};
}

pickerFilter.$inject = ['$filter'];

export default angular.module('filter.pickerFilter', [])
	.filter('pickerFilter', pickerFilter)
	.name;



// WEBPACK FOOTER //
// ./src/filter/picker.js